import Axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../../context/state";
import ScriptTag from "react-script-tag";
import "../../assets/vendors/css/charts/apexcharts.css";
import "../../assets/vendors/css/extensions/dragula.min.css";
import "../../assets/css/pages/dashboard-analytics.css";

//locall
import "./Home.css";
import useScript from "../../utils/useScript";
import { addCommas, useRequest } from "../../utils";

const Home = (props) => {
  const [get_info_error, get_info_loading, get_info_data, get_info_function] =
    useRequest({
      method: "get",
      url: "/get_info",
    });

  const data = get_info_data?.data;

  // console.log(get_info_data);

  useEffect(() => {
    Apex.chart = {
      fontFamily: "inherit",
      locales: [
        {
          name: "fa",
          options: {
            months: [
              "ژانویه",
              "فوریه",
              "مارس",
              "آوریل",
              "می",
              "ژوئن",
              "جولای",
              "آگوست",
              "سپتامبر",
              "اکتبر",
              "نوامبر",
              "دسامبر",
            ],
            shortMonths: [
              "ژانویه",
              "فوریه",
              "مارس",
              "آوریل",
              "می",
              "ژوئن",
              "جولای",
              "آگوست",
              "سپتامبر",
              "اکتبر",
              "نوامبر",
              "دسامبر",
            ],
            days: [
              "یکشنبه",
              "دوشنبه",
              "سه‌شنبه",
              "چهارشنبه",
              "پنجشنبه",
              "جمعه",
              "شنبه",
            ],
            shortDays: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
            toolbar: {
              exportToSVG: "دریافت SVG",
              exportToPNG: "دریافت PNG",
              menu: "فهرست",
              selection: "انتخاب",
              selectionZoom: "بزرگنمایی قسمت انتخاب شده",
              zoomIn: "بزرگ نمایی",
              zoomOut: "کوچک نمایی",
              pan: "جا به جایی",
              reset: "بازنشانی بزرگ نمایی",
            },
          },
        },
      ],
      defaultLocale: "fa",
    };

    var $primary = "#5A8DEE";
    var $success = "#39DA8A";
    var $danger = "#FF5B5C";
    var $warning = "#FDAC41";
    var $info = "#00CFDD";
    var $label_color = "#475f7b";
    var $primary_light = "#E2ECFF";
    var $danger_light = "#ffeed9";
    var $gray_light = "#828D99";
    var $sub_label_color = "#596778";
    var $radial_bg = "#e7edf3";

    // Radial-Success-chart
    // --------------------------------
    var radialSuccessoptions = {
      chart: {
        height: 40,
        width: 40,
        type: "radialBar",
      },
      grid: {
        show: false,
        padding: {
          left: -30,
          right: -30,
          top: 0,
        },
      },
      series: [100],
      colors: [$success],
      plotOptions: {
        radialBar: {
          hollow: {
            size: "30%",
          },
          dataLabels: {
            showOn: "always",
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          gradientToColors: [$success],
          opacityFrom: 1,
          opacityTo: 0.8,
          stops: [0, 70, 100],
        },
      },
      stroke: {
        lineCap: "round",
      },
    };
    var radialSuccessChart = new ApexCharts(
      document.querySelector("#radial-success-chart"),
      radialSuccessoptions
    );

    radialSuccessChart.render();

    // Radial-Warning-chart
    // --------------------------------
    var radialWarningoptions = {
      chart: {
        height: 40,
        width: 40,
        type: "radialBar",
      },
      grid: {
        show: false,
        padding: {
          left: -30,
          right: -30,
          top: 0,
        },
      },
      series: [100],
      colors: [$warning],
      plotOptions: {
        radialBar: {
          hollow: {
            size: "30%",
          },
          dataLabels: {
            showOn: "always",
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          gradientToColors: [$warning],
          opacityFrom: 1,
          opacityTo: 0.8,
          stops: [0, 70, 100],
        },
      },
      stroke: {
        lineCap: "round",
      },
    };
    var radialWarningChart = new ApexCharts(
      document.querySelector("#radial-warning-chart"),
      radialWarningoptions
    );

    radialWarningChart.render();

    // Radial-Danger-chart
    // --------------------------------
    var radialDangeroptions = {
      chart: {
        height: 40,
        width: 40,
        type: "radialBar",
      },
      grid: {
        show: false,
        padding: {
          left: -30,
          right: -30,
          top: 0,
        },
      },
      series: [100],
      colors: [$danger],
      plotOptions: {
        radialBar: {
          hollow: {
            size: "30%",
          },
          dataLabels: {
            showOn: "always",
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          gradientToColors: [$danger],
          opacityFrom: 1,
          opacityTo: 0.8,
          stops: [0, 70, 100],
        },
      },
      stroke: {
        lineCap: "round",
      },
    };
    var radialDangerChart = new ApexCharts(
      document.querySelector("#radial-danger-chart"),
      radialDangeroptions
    );

    radialDangerChart.render();

    // Bar Chart
    // ---------
    var analyticsBarChartOptions = {
      chart: {
        height: 260,
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "20%",
          endingShape: "rounded",
        },
      },
      legend: {
        horizontalAlign: "right",
        offsetY: -10,
        markers: {
          radius: 50,
          height: 8,
          width: 8,
        },
      },
      dataLabels: {
        enabled: false,
      },
      colors: [$primary, $primary_light],
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "vertical",
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 70, 100],
        },
      },
      series: [
        {
          name: "1399",
          data: [80, 95, 150, 210, 140, 230, 300, 280, 130],
        },
        {
          name: "1398",
          data: [50, 70, 130, 180, 90, 180, 270, 220, 110],
        },
      ],
      xaxis: {
        categories: [
          "فروردین",
          "اردیبهشت",
          "خرداد",
          "تیر",
          "مرداد",
          "شهریور",
          "مهر",
          "آبان",
          "آذر",
        ],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          style: {
            colors: $gray_light,
          },
        },
      },
      yaxis: {
        min: 0,
        max: 300,
        tickAmount: 3,
        labels: {
          style: {
            color: $gray_light,
          },
        },
      },
      legend: {
        show: false,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + " هزار تومان";
          },
        },
      },
    };

    var analyticsBarChart = new ApexCharts(
      document.querySelector("#analytics-bar-chart"),
      analyticsBarChartOptions
    );

    analyticsBarChart.render();

    // Success Line Chart
    // -----------------------------
    var successLineChartOption = {
      chart: {
        height: 100,
        type: "line",
        toolbar: {
          show: false,
        },
      },
      grid: {
        show: false,
        padding: {
          bottom: -20,
        },
      },
      colors: [$success],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 3,
        curve: "smooth",
      },
      series: [
        {
          name: "سری 1",
          data: [50, 0, 50, 40, 90, 0, 40, 25, 80, 40, 45],
        },
      ],
      xaxis: {
        show: false,
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        show: false,
      },
    };

    var successLineChart = new ApexCharts(
      document.querySelector("#success-line-chart"),
      successLineChartOption
    );
    successLineChart.render();

    // Donut Chart
    // ---------------------
    var donutChartOption = {
      chart: {
        width: 200,
        type: "donut",
      },
      dataLabels: {
        enabled: false,
      },
      series: [80, 30, 60],
      labels: ["اجتماعی", "ایمیل", "جستجو"],
      stroke: {
        width: 0,
        lineCap: "round",
      },
      colors: [$primary, $info, $warning],
      plotOptions: {
        pie: {
          donut: {
            size: "90%",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: "15px",
                colors: $sub_label_color,
                offsetY: 15,
              },
              value: {
                show: true,
                fontSize: "26px",
                color: $label_color,
                offsetY: -25,
                formatter: function (val) {
                  return val;
                },
              },
              total: {
                show: true,
                label: "بازدید",
                color: $gray_light,
                formatter: function (w) {
                  return w.globals.seriesTotals.reduce(function (a, b) {
                    return a + b;
                  }, 0);
                },
              },
            },
          },
        },
      },
      legend: {
        show: false,
      },
    };

    var donutChart = new ApexCharts(
      document.querySelector("#donut-chart"),
      donutChartOption
    );

    donutChart.render();

    // Stacked Bar Nagetive Chart
    // ----------------------------------
    var barNegativeChartoptions = {
      chart: {
        height: 110,
        stacked: true,
        type: "bar",
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "20%",
          endingShape: "rounded",
        },
        distributed: true,
      },
      colors: [$primary, $warning],
      series: [
        {
          name: "مشتریان جدید",
          data: [
            75, 150, 225, 200, 35, 50, 150, 180, 50, 150, 240, 140, 75, 35, 60,
            120,
          ],
        },
        {
          name: "مشتریان ثابت",
          data: [
            -100, -55, -40, -120, -70, -40, -60, -50, -70, -30, -60, -40, -50,
            -70, -40, -50,
          ],
        },
      ],
      grid: {
        show: false,
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        x: {
          show: false,
        },
      },
    };

    var barNegativeChart = new ApexCharts(
      document.querySelector("#bar-negative-chart"),
      barNegativeChartoptions
    );

    barNegativeChart.render();

    // Primary Line Chart
    // -----------------------------
    var primaryLineChartOption = {
      chart: {
        height: 40,
        // width: 180,
        type: "line",
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true,
        },
      },
      grid: {
        show: false,
        padding: {
          bottom: 5,
          top: 5,
          left: 10,
          right: 0,
        },
      },
      colors: [$primary],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 3,
        curve: "smooth",
      },
      series: [
        {
          name: "سری 1",
          data: [50, 100, 0, 60, 20, 30],
        },
      ],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          gradientToColors: [$primary],
          opacityFrom: 0,
          opacityTo: 0.9,
          stops: [0, 30, 70, 100],
        },
      },
      xaxis: {
        show: false,
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        show: false,
      },
    };

    var primaryLineChart = new ApexCharts(
      document.querySelector("#primary-line-chart"),
      primaryLineChartOption
    );
    primaryLineChart.render();

    // Warning Line Chart
    // -----------------------------
    var warningLineChartOption = {
      chart: {
        height: 40,
        // width: 90,
        type: "line",
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true,
        },
      },
      grid: {
        show: false,
        padding: {
          bottom: 5,
          top: 5,
          left: 10,
          right: 0,
        },
      },
      colors: [$warning],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 3,
        curve: "smooth",
      },
      series: [
        {
          name: "سری 1",
          data: [30, 60, 30, 80, 20, 70],
        },
      ],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          gradientToColors: [$warning],
          opacityFrom: 0,
          opacityTo: 0.9,
          stops: [0, 30, 70, 100],
        },
      },
      xaxis: {
        show: false,
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        show: false,
      },
    };

    var warningLineChart = new ApexCharts(
      document.querySelector("#warning-line-chart"),
      warningLineChartOption
    );
    warningLineChart.render();

    // Profit Primary Chart
    // --------------------------------
    var profitPrimaryOptions = {
      chart: {
        height: 40,
        width: 40,
        type: "radialBar",
        sparkline: {
          show: true,
        },
      },
      grid: {
        show: false,
        padding: {
          left: -30,
          right: -30,
          top: 0,
          bottom: -70,
        },
      },
      series: [50],
      colors: [$primary],
      plotOptions: {
        radialBar: {
          hollow: {
            size: "30%",
          },
          dataLabels: {
            showOn: "always",
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
        },
      },
      stroke: {
        lineCap: "round",
      },
    };
    var profitPrimaryChart = new ApexCharts(
      document.querySelector("#profit-primary-chart"),
      profitPrimaryOptions
    );

    profitPrimaryChart.render();

    // Profit Info Chart
    // --------------------------------
    var profitInfoOptions = {
      chart: {
        height: 40,
        width: 40,
        type: "radialBar",
        sparkline: {
          show: true,
        },
      },
      grid: {
        show: false,
        padding: {
          left: -30,
          right: -30,
          top: 0,
          bottom: -70,
        },
      },
      series: [70],
      colors: [$info],
      plotOptions: {
        radialBar: {
          hollow: {
            size: "30%",
          },
          dataLabels: {
            showOn: "always",
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
        },
      },
      stroke: {
        lineCap: "round",
      },
    };
    var profitInfoChart = new ApexCharts(
      document.querySelector("#profit-info-chart"),
      profitInfoOptions
    );

    profitInfoChart.render();

    // Registration Chart
    // -------------------
    var registrationChartoptions = {
      chart: {
        type: "bar",
        height: 60,
        width: 120,
        sparkline: {
          enabled: true,
        },
        toolbar: {
          show: false,
        },
      },
      states: {
        hover: {
          filter: "none",
        },
      },
      colors: [
        $danger_light,
        $danger_light,
        $danger_light,
        $danger_light,
        $warning,
        $danger_light,
      ],
      series: [
        {
          name: "جلسات",
          data: [3, 7, 5, 15, 9, 8, 12],
        },
      ],
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
        },
      },

      plotOptions: {
        bar: {
          columnWidth: "80%",
          distributed: true,
        },
      },
      tooltip: {
        x: {
          show: false,
        },
      },
      xaxis: {
        type: "numeric",
      },
    };

    var registrationChart = new ApexCharts(
      document.querySelector("#registration-chart"),
      registrationChartoptions
    );

    registrationChart.render();

    // Sales Chart
    // ---------------------
    var salesChartOptions = {
      chart: {
        height: 100,
        type: "bar",
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
          top: -20,
          bottom: -15,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "20%",
          endingShape: "rounded",
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      colors: [$primary, $primary_light],
      series: [
        {
          name: "1399",
          data: [80, 40, 30, 90, 20, 50, 95],
        },
        {
          name: "1398",
          data: [20, 60, 70, 10, 80, 50, 5],
        },
      ],
      xaxis: {
        categories: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          style: {
            colors: $gray_light,
          },
          offsetY: -5,
        },
      },
      yaxis: {
        show: false,
        floating: true,
      },
      tooltip: {
        x: {
          show: false,
        },
      },
    };

    var salesChart = new ApexCharts(
      document.querySelector("#sales-chart"),
      salesChartOptions
    );

    salesChart.render();

    // Growth Radial Chart
    // --------------------
    var growthChartOptions = {
      chart: {
        height: 200,
        type: "radialBar",
        sparkline: {
          show: true,
        },
      },
      grid: {
        show: false,
      },
      plotOptions: {
        radialBar: {
          size: 100,
          startAngle: -135,
          endAngle: 135,
          offsetY: 40,
          hollow: {
            size: "60%",
          },
          track: {
            strokeWidth: "90%",
            background: "#fff",
          },
          dataLabels: {
            value: {
              offsetY: -20,
              color: "#475f7b",
              fontSize: "26px",
            },
            name: {
              fontSize: "15px",
              color: "#596778",
              offsetY: 22,
            },
          },
        },
      },
      colors: [$danger],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.5,
          gradientToColors: [$primary],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        dashArray: 3,
      },
      series: [78],
      labels: ["رشد"],
    };

    var growthChart = new ApexCharts(
      document.querySelector("#growth-Chart"),
      growthChartOptions
    );

    growthChart.render();

    // Widget Todo List
    // ------------------
    // Task List Widget - for completed todo item
    $(document).on("click", ".widget-todo-item input", function () {
      $(this).closest(".widget-todo-item").toggleClass("completed");
    });

    // Drag the task
    dragula([document.getElementById("widget-todo-list")], {
      moves: function (el, container, handle) {
        return handle.classList.contains("cursor-move");
      },
    });
  }, []);

  return (
    <div className="homeContainer" style={{ marginTop: "50px" }}>
      <section id="dashboard-analytics" style={{ width: "100%" }}>
        <div class="row">
          {/* <!-- Website Analytics Starts--> */}
          <div class="col-md-6 col-sm-12">
            <div class="card">
              <div class="card-header d-flex justify-content-between align-items-center">
                <h4 class="card-title">آمار وب سایت</h4>
                <i class="bx bx-dots-vertical-rounded font-medium-3 cursor-pointer"></i>
              </div>
              <div class="card-content">
                <div class="card-body pb-1">
                  <div class="d-flex justify-content-around align-items-center flex-wrap">
                    <div class="user-analytics">
                      <i class="bx bx-user mr-25 align-middle"></i>
                      <span class="align-middle text-muted">کاربران</span>
                      <div class="d-flex">
                        <div id="radial-success-chart"></div>
                        <h3 class="mt-1 ml-50 primary-font">
                          {data?.user_count}
                        </h3>
                      </div>
                    </div>
                    <div class="sessions-analytics">
                      <i class="bx bx-trending-up align-middle mr-25"></i>
                      <span class="align-middle text-muted">تراکنش ها</span>
                      <div class="d-flex">
                        <div id="radial-warning-chart"></div>
                        <h3 class="mt-1 ml-50 primary-font">
                          {data?.payment_count}
                        </h3>
                      </div>
                    </div>
                    <div class="bounce-rate-analytics">
                      <i class="bx bx-pie-chart-alt align-middle mr-25"></i>
                      <span class="align-middle text-muted">کامنت ها</span>
                      <div class="d-flex">
                        <div id="radial-danger-chart"></div>
                        <h3 class="mt-1 ml-50 primary-font">
                          {data?.comment_count}
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* <div id="analytics-bar-chart"></div> */}
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-6 col-sm-12 dashboard-referral-impression">
            <div class="row">
              {/* <!-- Referral Chart Starts--> */}
              <div class="col-12">
                <div class="card">
                  <div class="card-body d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center my-n50">
                      <div class="avatar bg-rgba-warning m-0 p-25 mr-75 mr-xl-2">
                        <div class="avatar-content">
                          <i class="bx bx-dollar text-warning font-medium-2"></i>
                        </div>
                      </div>
                      <div class="total-amount mt-n50">
                        <h5 class="mb-0 primary-font">
                          {data?.unverified_payments}
                        </h5>
                        <small class="text-muted"> تراکنش های بررسی نشده</small>
                      </div>
                    </div>
                    {/* <div id="warning-line-chart"></div> */}
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="card">
                  <div class="card-body d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center my-n50">
                      <div class="avatar bg-rgba-warning m-0 p-25 mr-75 mr-xl-2">
                        <div class="avatar-content">
                          <i class="bx bx-dollar text-warning font-medium-2"></i>
                        </div>
                      </div>
                      <div class="total-amount mt-n50">
                        <h5 class="mb-0 primary-font">
                          {data
                            ? data.total_previous_month_transactions[0]
                              ? addCommas(
                                  data.total_previous_month_transactions[0]
                                    ._price
                                )
                              : "0"
                            : "0"}
                          تومان
                        </h5>
                        <small class="text-muted">
                          مبلغ تراکنش های موفق این ماه
                        </small>
                      </div>
                    </div>
                    {/* <div id="warning-line-chart"></div> */}
                  </div>
                </div>
              </div>

              {/* <!-- Impression Radial Chart Starts--> */}
              {/* <div class="col-xl-12 col-12">
                <div class="card">
                  <div class="card-content">
                    <div class="card-body donut-chart-wrapper">
                      <div
                        id="donut-chart"
                        class="d-flex justify-content-center"
                      ></div>
                      <ul class="list-inline d-flex justify-content-around mb-0">
                        <li>
                          {" "}
                          <span class="bullet bullet-xs bullet-warning mr-50"></span>
                          جستجو
                        </li>
                        <li>
                          {" "}
                          <span class="bullet bullet-xs bullet-info mr-50"></span>
                          ایمیل
                        </li>
                        <li>
                          {" "}
                          <span class="bullet bullet-xs bullet-primary mr-50"></span>
                          اجتماعی
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div class="col-xl-3 col-md-12 col-sm-12">
            <div class="row">
              {/* <!-- Conversion Chart Starts--> */}
              {/* <div class="col-xl-12 col-md-6 col-12">
                <div class="card">
                  <div class="card-header d-flex justify-content-between pb-xl-0 pt-xl-1">
                    <div class="conversion-title">
                      <h4 class="card-title mb-0">تبدیل</h4>
                      <p>
                        60%
                        <i class="bx bx-trending-up text-success font-size-small align-middle mr-25"></i>
                      </p>
                    </div>
                    <div class="conversion-rate">
                      <h2 class="primary-font">89k</h2>
                    </div>
                  </div>
                  <div class="card-content">
                    <div class="card-body text-center">
                      <div id="bar-negative-chart"></div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div class="col-xl-12 col-md-6 col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center my-n50">
                          <div class="avatar bg-rgba-primary m-0 p-25 mr-75 mr-xl-2">
                            <div class="avatar-content">
                              <i class="bx bx-user text-primary font-medium-2"></i>
                            </div>
                          </div>
                          <div class="total-amount mt-n50">
                            <h5 class="mb-0 primary-font">
                              {data?.unanswered_calls}
                            </h5>
                            <small class="text-muted">
                              تماس باما بدون جواب
                            </small>
                          </div>
                        </div>
                        {/* <div id="primary-line-chart"></div> */}
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center my-n50">
                          <div class="avatar bg-rgba-primary m-0 p-25 mr-75 mr-xl-2">
                            <div class="avatar-content">
                              <i class="bx bx-user text-primary font-medium-2"></i>
                            </div>
                          </div>
                          <div class="total-amount mt-n50">
                            <h5 class="mb-0 primary-font">
                              {data?.registered_users_today}
                            </h5>
                            <small class="text-muted">
                              کاربران ثبت نامی امروز
                            </small>
                          </div>
                        </div>
                        {/* <div id="primary-line-chart"></div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          {/* <!-- Activity Card Starts--> */}
          {/* <div class="col-xl-3 col-md-6 col-12 activity-card">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">فعالیت</h4>
              </div>
              <div class="card-content">
                <div class="card-body pt-1">
                  <div class="d-flex activity-content align-items-center">
                    <div class="avatar mt-25 bg-rgba-primary m-0 mr-75">
                      <div class="avatar-content">
                        <i class="bx bx-bar-chart-alt-2 text-primary"></i>
                      </div>
                    </div>
                    <div class="activity-progress flex-grow-1">
                      <small class="text-muted d-inline-block align-top mb-75">
                        مجموع فروش
                      </small>
                      <small class="float-right">8,125 تومان</small>
                      <div class="progress progress-bar-primary progress-sm">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          aria-valuenow="50"
                          style="width:50%"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex activity-content align-items-center">
                    <div class="avatar mt-25 bg-rgba-success m-0 mr-75">
                      <div class="avatar-content">
                        <i class="bx bx-dollar text-success"></i>
                      </div>
                    </div>
                    <div class="activity-progress flex-grow-1">
                      <small class="text-muted d-inline-block align-top mb-75">
                        مقدار واریزی
                      </small>
                      <small class="float-right">18,963 تومان</small>
                      <div class="progress progress-bar-success progress-sm">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          aria-valuenow="80"
                          style="width:80%"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex activity-content align-items-center">
                    <div class="avatar mt-25 bg-rgba-warning m-0 mr-75">
                      <div class="avatar-content">
                        <i class="bx bx-stats text-warning"></i>
                      </div>
                    </div>
                    <div class="activity-progress flex-grow-1">
                      <small class="text-muted d-inline-block align-top mb-75">
                        کل بودجه
                      </small>
                      <small class="float-right">14,150 تومان</small>
                      <div class="progress progress-bar-warning progress-sm">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          aria-valuenow="60"
                          style="width:60%"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mb-1">
                    <div class="avatar mt-25 bg-rgba-danger m-0 mr-75">
                      <div class="avatar-content">
                        <i class="bx bx-check text-danger"></i>
                      </div>
                    </div>
                    <div class="activity-progress flex-grow-1">
                      <small class="text-muted d-inline-block align-top mb-75">
                        وظایف انجام شده
                      </small>
                      <small class="float-right">106</small>
                      <div class="progress progress-bar-danger progress-sm">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          aria-valuenow="30"
                          style="width:30%"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <!-- Profit Report Card Starts--> */}
          <div class="col-xl-3 col-md-6 col-12 profit-report-card">
            {/* <div class="row">
              <div class="col-md-12 col-sm-6">
                <div class="card">
                  <div class="card-header d-flex justify-content-between align-items-center">
                    <h4 class="card-title">گزارش فروش</h4>
                    <i class="bx bx-dots-vertical-rounded font-medium-3 cursor-pointer"></i>
                  </div>
                  <div class="card-content">
                    <div class="card-body pb-0 d-flex justify-content-around">
                      <div class="d-inline-flex mr-xl-2 mt-50">
                        <div id="profit-primary-chart"></div>
                        <div class="profit-content ml-50 mt-50 mb-1">
                          <h5 class="mb-25 primary-font">12.5K</h5>
                          <small class="text-muted">1399</small>
                        </div>
                      </div>
                      <div class="d-inline-flex mt-50">
                        <div id="profit-info-chart"></div>
                        <div class="profit-content ml-50 mt-50 mb-1">
                          <h5 class="mb-25 primary-font">64.8K</h5>
                          <small class="text-muted">1398</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-sm-6">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">ثبت نام ها</h4>
                  </div>
                  <div class="card-content">
                    <div class="card-body">
                      <div class="d-flex align-items-end justify-content-around mt-50 mb-25">
                        <div class="registration-content mr-xl-2">
                          <h4 class="mb-0 primary-font">56.3k</h4>
                          <i class="bx bx-trending-up success align-middle"></i>
                          <span class="text-success">12%</span>
                        </div>
                        <div id="registration-chart"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
          {/* <!-- Sales Chart Starts--> */}
          {/* <div class="col-xl-3 col-md-6 col-12 sales-card">
            <div class="card">
              <div class="card-header d-flex justify-content-between align-items-center">
                <div class="card-title-content">
                  <h4 class="card-title mb-25">فروش‌ها</h4>
                  <small class="text-muted">محاسبه شده در 7 روز اخیر</small>
                </div>
                <i class="bx bx-dots-vertical-rounded font-medium-3 cursor-pointer"></i>
              </div>
              <div class="card-content">
                <div class="card-body">
                  <div id="sales-chart" class="mb-2"></div>
                  <div class="d-flex justify-content-between my-1">
                    <div class="sales-info d-flex align-items-center">
                      <i class="bx bx-up-arrow-circle text-primary font-medium-5 mr-50"></i>
                      <div class="sales-info-content">
                        <h6 class="mb-0 mt-n50 primary-font">بهترین فروش</h6>
                        <small class="text-muted">یک شنبه</small>
                      </div>
                    </div>
                    <h6 class="mb-0 line-height-1 primary-font">28.6k</h6>
                  </div>
                  <div class="d-flex justify-content-between mt-2">
                    <div class="sales-info d-flex align-items-center">
                      <i class="bx bx-down-arrow-circle icon-light font-medium-5 mr-50"></i>
                      <div class="sales-info-content">
                        <h6 class="mb-0 mt-n50 primary-font">کمترین فروش</h6>
                        <small class="text-muted">پنج شنبه</small>
                      </div>
                    </div>
                    <h6 class="mb-0 line-height-1 primary-font">986k</h6>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <!-- Growth Chart Starts--> */}
          {/* <div class="col-xl-3 col-md-6 col-12 growth-card">
            <div class="card">
              <div class="card-body text-center">
                <div class="dropdown">
                  <button
                    class="btn btn-sm btn-outline-secondary dropdown-toggle"
                    type="button"
                    id="dropdownMenuButtonSec"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    1399
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dropdownMenuButtonSec"
                  >
                    <a class="dropdown-item" href="#">
                      1399
                    </a>
                    <a class="dropdown-item" href="#">
                      1398
                    </a>
                    <a class="dropdown-item" href="#">
                      1397
                    </a>
                  </div>
                </div>
                <div id="growth-Chart" class="my-75"></div>
                <h6 class="mb-0"> 62% رشد شرکت در 1398</h6>
              </div>
            </div>
          </div> */}
        </div>

        <div class="row">
          {/* <!-- Task Card Starts --> */}
          {/* <div class="col-lg-7">
            <div class="row">
              <div class="col-12">
                <div class="card widget-todo">
                  <div class="card-header border-bottom d-flex justify-content-between align-items-center flex-wrap">
                    <h4 class="card-title d-flex align-items-center mb-25 mb-sm-n50 mt-n50">
                      <i class="bx bx-check font-medium-5 pl-25 pr-75"></i>وظایف
                    </h4>
                    <ul class="list-inline d-flex mb-25 mb-sm-0">
                      <li class="d-flex align-items-center">
                        <i class="bx bx-check-circle font-medium-3 mr-50"></i>
                        <div class="dropdown">
                          <div
                            class="dropdown-toggle mr-1 cursor-pointer"
                            role="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            همه وظایف
                          </div>
                          <div
                            class="dropdown-menu dropdown-menu-right"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <a class="dropdown-item" href="#">
                              گزینه 1
                            </a>
                            <a class="dropdown-item" href="#">
                              گزینه 2
                            </a>
                            <a class="dropdown-item" href="#">
                              گزینه 3
                            </a>
                          </div>
                        </div>
                      </li>
                      <li class="d-flex align-items-center">
                        <i class="bx bx-sort mr-50 font-medium-3"></i>
                        <div class="dropdown">
                          <div
                            class="dropdown-toggle cursor-pointer"
                            role="button"
                            id="dropdownMenuButton2"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            همه وظایف
                          </div>
                          <div
                            class="dropdown-menu dropdown-menu-right"
                            aria-labelledby="dropdownMenuButton2"
                          >
                            <a class="dropdown-item" href="#">
                              گزینه 1
                            </a>
                            <a class="dropdown-item" href="#">
                              گزینه 2
                            </a>
                            <a class="dropdown-item" href="#">
                              گزینه 3
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="card-body px-0 py-1">
                    <ul class="widget-todo-list-wrapper" id="widget-todo-list">
                      <li class="widget-todo-item">
                        <div class="widget-todo-title-wrapper d-flex justify-content-between align-items-center mb-50">
                          <div class="widget-todo-title-area d-flex align-items-center">
                            <i class="bx bx-grid-vertical mr-25 font-medium-4 cursor-move"></i>
                            <div class="checkbox checkbox-shadow">
                              <input
                                type="checkbox"
                                class="checkbox__input"
                                id="checkbox1"
                              />
                              <label for="checkbox1"></label>
                            </div>
                            <span class="widget-todo-title mx-50">
                              لورم ایپسوم متن ساختگی با تولید سادگی
                            </span>
                          </div>
                          <div class="widget-todo-item-action d-flex align-items-center">
                            <div class="badge badge-pill badge-light-success mr-1">
                              فرانت اند
                            </div>
                            <div class="avatar bg-rgba-primary m-0 mr-50">
                              <div class="avatar-content">
                                <span class="font-size-base text-primary">
                                  رآ
                                </span>
                              </div>
                            </div>
                            <div class="dropdown">
                              <span
                                class="bx bx-dots-vertical-rounded font-medium-3 dropdown-toggle nav-hide-arrow cursor-pointer icon-light"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                role="menu"
                              ></span>
                              <div class="dropdown-menu">
                                <a class="dropdown-item" href="#">
                                  <i class="bx bx-edit-alt mr-1"></i> ویرایش
                                </a>
                                <a class="dropdown-item" href="#">
                                  <i class="bx bx-trash mr-1"></i> حذف
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="widget-todo-item">
                        <div class="widget-todo-title-wrapper d-flex justify-content-between align-items-center mb-50">
                          <div class="widget-todo-title-area d-flex align-items-center">
                            <i class="bx bx-grid-vertical mr-25 font-medium-4 cursor-move"></i>
                            <div class="checkbox checkbox-shadow">
                              <input
                                type="checkbox"
                                class="checkbox__input"
                                id="checkbox2"
                              />
                              <label for="checkbox2"></label>
                            </div>
                            <span class="widget-todo-title mx-50">
                              لورم ایپسوم متن ساختگی با تولید سادگی
                            </span>
                          </div>
                          <div class="widget-todo-item-action d-flex align-items-center">
                            <div class="badge badge-pill badge-light-danger mr-1">
                              بک اند
                            </div>
                            <div class="avatar m-0 mr-50">
                              <img
                                src="../../assets/images/profile/user-uploads/social-2.jpg"
                                alt="img placeholder"
                                height="32"
                                width="32"
                              />
                            </div>
                            <div class="dropdown">
                              <span
                                class="bx bx-dots-vertical-rounded font-medium-3 dropdown-toggle nav-hide-arrow cursor-pointer icon-light"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                role="menu"
                              ></span>
                              <div class="dropdown-menu">
                                <a class="dropdown-item" href="#">
                                  <i class="bx bx-edit-alt mr-1"></i> ویرایش
                                </a>
                                <a class="dropdown-item" href="#">
                                  <i class="bx bx-trash mr-1"></i> حذف
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="widget-todo-item completed">
                        <div class="widget-todo-title-wrapper d-flex justify-content-between align-items-center mb-50">
                          <div class="widget-todo-title-area d-flex align-items-center">
                            <i class="bx bx-grid-vertical mr-25 font-medium-4 cursor-move"></i>
                            <div class="checkbox checkbox-shadow">
                              <input
                                type="checkbox"
                                class="checkbox__input"
                                id="checkbox3"
                                checked
                              />
                              <label for="checkbox3"></label>
                            </div>
                            <span class="widget-todo-title mx-50">
                              لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم
                            </span>
                          </div>
                          <div class="widget-todo-item-action d-flex align-items-center">
                            <div class="badge badge-pill badge-light-primary mr-1">
                              UI/UX
                            </div>
                            <div class="avatar bg-rgba-primary m-0 mr-50">
                              <div class="avatar-content">
                                <span class="font-size-base text-primary">
                                  ج‌د
                                </span>
                              </div>
                            </div>
                            <div class="dropdown">
                              <span
                                class="bx bx-dots-vertical-rounded font-medium-3 dropdown-toggle nav-hide-arrow cursor-pointer icon-light"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                role="menu"
                              ></span>
                              <div class="dropdown-menu">
                                <a class="dropdown-item" href="#">
                                  <i class="bx bx-edit-alt mr-1"></i> ویرایش
                                </a>
                                <a class="dropdown-item" href="#">
                                  <i class="bx bx-trash mr-1"></i> حذف
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="widget-todo-item">
                        <div class="widget-todo-title-wrapper d-flex justify-content-between align-items-center mb-50">
                          <div class="widget-todo-title-area d-flex align-items-center">
                            <i class="bx bx-grid-vertical mr-25 font-medium-4 cursor-move"></i>
                            <div class="checkbox checkbox-shadow">
                              <input
                                type="checkbox"
                                class="checkbox__input"
                                id="checkbox4"
                              />
                              <label for="checkbox4"></label>
                            </div>
                            <span class="widget-todo-title mx-50">
                              لورم ایپسوم متن ساختگی با تولید سادگی
                            </span>
                          </div>
                          <div class="widget-todo-item-action d-flex align-items-center">
                            <div class="badge badge-pill badge-light-info mr-1">
                              طراحی
                            </div>
                            <div class="avatar m-0 mr-50">
                              <img
                                src="../../assets/images/profile/user-uploads/user-05.jpg"
                                alt="img placeholder"
                                height="32"
                                width="32"
                              />
                            </div>
                            <div class="dropdown">
                              <span
                                class="bx bx-dots-vertical-rounded font-medium-3 dropdown-toggle nav-hide-arrow cursor-pointer icon-light"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                role="menu"
                              ></span>
                              <div class="dropdown-menu">
                                <a class="dropdown-item" href="#">
                                  <i class="bx bx-edit-alt mr-1"></i> ویرایش
                                </a>
                                <a class="dropdown-item" href="#">
                                  <i class="bx bx-trash mr-1"></i> حذف
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="widget-todo-item">
                        <div class="widget-todo-title-wrapper d-flex justify-content-between align-items-center mb-50">
                          <div class="widget-todo-title-area d-flex align-items-center">
                            <i class="bx bx-grid-vertical mr-25 font-medium-4 cursor-move"></i>
                            <div class="checkbox checkbox-shadow">
                              <input
                                type="checkbox"
                                class="checkbox__input"
                                id="checkbox5"
                              />
                              <label for="checkbox5"></label>
                            </div>
                            <span class="widget-todo-title mx-50">
                              لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                              صنعت چاپ
                            </span>
                          </div>
                          <div class="widget-todo-item-action d-flex align-items-center">
                            <div class="badge badge-pill badge-light-warning mr-1">
                              Javascript
                            </div>
                            <div class="avatar bg-rgba-primary m-0 mr-50">
                              <div class="avatar-content">
                                <span class="font-size-base text-primary">
                                  اک
                                </span>
                              </div>
                            </div>
                            <div class="dropdown">
                              <span
                                class="bx bx-dots-vertical-rounded font-medium-3 dropdown-toggle nav-hide-arrow cursor-pointer icon-light"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                role="menu"
                              ></span>
                              <div class="dropdown-menu">
                                <a class="dropdown-item" href="#">
                                  <i class="bx bx-edit-alt mr-1"></i> ویرایش
                                </a>
                                <a class="dropdown-item" href="#">
                                  <i class="bx bx-trash mr-1"></i> حذف
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="widget-todo-item">
                        <div class="widget-todo-title-wrapper d-flex justify-content-between align-items-center mb-50">
                          <div class="widget-todo-title-area d-flex align-items-center">
                            <i class="bx bx-grid-vertical mr-25 font-medium-4 cursor-move"></i>
                            <div class="checkbox checkbox-shadow">
                              <input
                                type="checkbox"
                                class="checkbox__input"
                                id="checkbox6"
                              />
                              <label for="checkbox6"></label>
                            </div>
                            <span class="widget-todo-title mx-50">
                              لورم ایپسوم متن ساختگی با
                            </span>
                          </div>
                          <div class="widget-todo-item-action d-flex align-items-center">
                            <div class="badge badge-pill badge-light-primary mr-1">
                              UI/UX
                            </div>
                            <div class="avatar m-0 mr-50">
                              <img
                                src="../../assets/images/profile/user-uploads/user-05.jpg"
                                alt="img placeholder"
                                height="32"
                                width="32"
                              />
                            </div>
                            <div class="dropdown">
                              <span
                                class="bx bx-dots-vertical-rounded font-medium-3 dropdown-toggle nav-hide-arrow cursor-pointer icon-light"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                role="menu"
                              ></span>
                              <div class="dropdown-menu">
                                <a class="dropdown-item" href="#">
                                  <i class="bx bx-edit-alt mr-1"></i> ویرایش
                                </a>
                                <a class="dropdown-item" href="#">
                                  <i class="bx bx-trash mr-1"></i> حذف
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <!-- Daily Financials Card Starts --> */}
          <div class="col-lg-5">
            {/* <div class="card ">
              <div class="card-header">
                <h4 class="card-title">خط زمانی سفارشات</h4>
              </div>
              <div class="card-content">
                <div class="card-body">
                  <ul class="widget-timeline mb-0">
                    <li class="timeline-items timeline-icon-primary active">
                      <div class="timeline-time">16 فروردین</div>
                      <h6 class="timeline-title">
                        1938، سفارشات، 4220 میلیون تومان
                      </h6>
                      <p class="timeline-text">2 ساعت پیش</p>
                      <div class="timeline-content">
                        <img
                          src="../../assets/images/icon/pdf.png"
                          alt="document"
                          height="23"
                          width="19"
                          class="mr-50"
                        />
                        Invoices.pdf
                      </div>
                    </li>
                    <li class="timeline-items timeline-icon-primary active">
                      <div class="timeline-time">17 فروردین</div>
                      <h6 class="timeline-title">12 صورتحساب پرداخت شد</h6>
                      <p class="timeline-text">25 دقیقه پیش</p>
                      <div class="timeline-content">
                        <img
                          src="../../assets/images/icon/pdf.png"
                          alt="document"
                          height="23"
                          width="19"
                          class="mr-50"
                        />
                        Invoices.pdf
                      </div>
                    </li>
                    <li class="timeline-items timeline-icon-primary active pb-0">
                      <div class="timeline-time">18 فروردین</div>
                      <h6 class="timeline-title">سفارش #37745 از فروردین</h6>
                      <p class="timeline-text">4 دقیقه پیش</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export { Home };
